var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixabayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 123.9",
    style: {
      enableBackground: "new 0 0 640 123.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-156.15726,-367.21451)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M679.7,407.4c-3.5-2.5-6-5-6-8h-19.3c0,5.5-2.5,8-5.6,8h-5.2v56.2h100.4v-56.2h-64.6H679.7z M673.7,423.4 h-18.1v-8h20.1v6.5L673.7,423.4z M707.7,454.7c-11.5,0-20.8-9.2-20.8-20.5s9.3-20,20.8-20c11.5,0,20.8,8.7,20.8,20 C728.4,445.5,719.1,454.7,707.7,454.7z M718.8,434.2c0,6.1-5,11-11.2,11c-6.2,0-11.2-4.9-11.2-11c0-6.1,5-11,11.2-11 C713.8,423.2,718.8,428.1,718.8,434.2L718.8,434.2z M796.2,399.7l-25,63.7l-19.2-7.7v-10.9l13.3,5.5l17.6-44.8L717,380.3l-6.1,19 h-11l11.2-32.1L796.2,399.7L796.2,399.7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.129044,0,0,4.129044,-488.6229,-1536.6294)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M164.4,468c4-0.1,7.8,3.2,8.2,7.2c0.5,3.5-1.6,7.2-4.8,8.6c-2,1-4.2,0.7-6.3,0.7h-2.1v6.6h-3.3 c0-5.1,0-10.2,0-15.3c0.1-3.8,3.2-7.2,7-7.7C163.5,468,164,468,164.4,468L164.4,468z M164.4,481.2c2.4,0.1,4.6-1.8,4.9-4.1 c0.5-2.4-1-4.9-3.3-5.6c-2.2-0.8-4.9,0.2-6,2.3c-0.8,1.4-0.5,3.1-0.6,4.7v2.7C161.1,481.2,162.7,481.2,164.4,481.2L164.4,481.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M174.2,467.9h3.2v16.5h-3.2V467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M187.1,478.3h0.1l4.6,6.1h4l-6.2-8.5l5.5-8h-4l-3.9,5.7h-0.1l-3.9-5.7h-4l5.5,8l-6.2,8.5h4L187.1,478.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M203.1,467.9c3.3-0.1,6.4,2.1,7.6,5.1c0.6,1.4,0.6,3,0.6,4.5v6.9c-2.9,0-5.8,0-8.7,0 c-3.4-0.2-6.4-2.6-7.4-5.8c-0.9-2.8-0.1-6,1.9-8.1C198.7,468.9,200.9,467.9,203.1,467.9L203.1,467.9z M208.1,481.1 c0-1.8,0-3.7,0-5.5c-0.2-2.5-2.5-4.5-4.9-4.5c-2.3-0.1-4.6,1.8-4.9,4.1c-0.4,2.2,0.8,4.7,3,5.5c1.3,0.6,2.8,0.3,4.1,0.4 C206.2,481.1,207.2,481.1,208.1,481.1L208.1,481.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M221.2,468c3.9-0.1,7.5,2.9,8.1,6.8c0.7,3.6-1.3,7.5-4.7,9c-3.3,1.6-7.5,0.6-9.8-2.3c-1.4-1.7-2-3.8-1.9-6 v-14.1h3.3v6.6C217.9,468,219.5,468,221.2,468L221.2,468z M221.2,481.2c2.5,0.1,4.8-2,4.9-4.5c0.3-2.5-1.5-4.9-3.9-5.4 c-1.3-0.2-2.7-0.1-4.1-0.1h-1.9c0,1.9,0,3.7,0,5.6C216.5,479.3,218.7,481.3,221.2,481.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M238.9,467.9c3.3-0.1,6.4,2.1,7.6,5.1c0.6,1.4,0.6,3,0.6,4.5v6.9c-2.9,0-5.8,0-8.7,0 c-3.4-0.2-6.4-2.6-7.4-5.8c-0.9-2.8-0.1-6,1.9-8.1C234.5,468.9,236.7,467.9,238.9,467.9L238.9,467.9z M243.9,481.1 c0-1.8,0-3.7,0-5.5c-0.2-2.5-2.5-4.5-4.9-4.5c-2.3-0.1-4.6,1.8-4.9,4.1c-0.4,2.2,0.8,4.7,3,5.5c1.3,0.6,2.8,0.3,4.1,0.4 C242,481.1,242.9,481.1,243.9,481.1L243.9,481.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M265.1,468c0,5.1,0,10.2,0,15.3c-0.1,4-3.6,7.6-7.6,7.8c-0.8,0-1.5,0-2.3,0v-3.3c1.4,0,2.9,0.1,4.1-0.7 c1.5-0.9,2.5-2.6,2.5-4.4c-2.9,2.3-7.4,2.2-10.2-0.2c-2.1-1.7-3.2-4.3-3-6.9V468h3.3c0,2.9,0,5.8,0,8.7c0.2,2.4,2.3,4.4,4.7,4.5 c2.4,0.2,4.8-1.7,5.1-4.1c0.1-1.4,0-2.9,0.1-4.3V468C262.9,468,264,468,265.1,468L265.1,468z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixabayLogo);
export default __webpack_public_path__ + "static/media/pixabay_logo.a3dd3f8a.svg";
export { ForwardRef as ReactComponent };